import React from 'react';
import { useApp } from '../../context/AppContext';

const FarmSelector = () => {
    const {
        selectedOrg,
        selectedFarm,
        setSelectedFarm,
        farmList,
        user
    } = useApp();

    if (user?.role !== 'super_admin' && (!selectedOrg || selectedOrg === 'all')) return null;

    return (
        <select
            value={selectedFarm || ''}
            onChange={(e) => setSelectedFarm(e.target.value)}
            className="p-2 border rounded-md bg-white border-r-8 border-transparent"
        >
            <option value="all">All Farms</option>
            {farmList.map(farm => (
                <option key={farm.id} value={farm.id}>
                    {farm.name}
                </option>
            ))}
        </select>
    );
};

export default FarmSelector; 